import { render, staticRenderFns } from "./SalesAgentModal.vue?vue&type=template&id=13b9c286&scoped=true&"
import script from "./SalesAgentModal.vue?vue&type=script&lang=js&"
export * from "./SalesAgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9c286",
  null
  
)

export default component.exports